export default __webpack_public_path__ + "static/media/forward.9b6f07ad.svg";